<app-back-header 
  [headerText]="'Torna alla lista'"
  (backAction)="onCancel()">
</app-back-header>

<h3>Dettagli prodotto:</h3>

<form [formGroup]="productForm" (ngSubmit)="onSubmit()">

  <mat-card class="mt-1 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card">
  <mat-card-content>

        <h5 class="mb-3">Dati del prodotto/servizio:</h5>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Nome</mat-label>
            <input matInput formControlName="name" required />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="type">
              <mat-option *ngFor="let type of typeOptions" [value]="type.code">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Unità di misura</mat-label>
            <input matInput formControlName="units" /> 
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Descrizione</mat-label>
            <input matInput formControlName="description" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Prezzo unitario</mat-label>
            <input matInput formControlName="unit_price" type="number" required />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Percentuale IVA</mat-label>
            <input matInput formControlName="iva_percentage" [attr.disabled]="true" />
          </mat-form-field>
        </div>

  </mat-card-content>

    <div class="mb-3 d-flex flex-column align-self-end">
      <div class="mt-2 mb-3 d-flex align-self-end">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="!productForm.valid"
          class="mt-2 me-3"
        >
        <mat-icon>save</mat-icon>
          Salva modifiche
        </button>
      </div>
    </div>

</mat-card>

<div class="pt-3 mb-3"></div>


</form>
